module.exports = __webpack_public_path__ + "img/rainbow.3e8164f4.png";